import { useState } from "react"
import './Footer.css'
import { MdOutlineEmail } from "react-icons/md";
import { FcCallback } from "react-icons/fc";
import { Link } from "react-router-dom";



export default function Footer() {
    const [email, setEmail] = useState('')
    const tag = 'Footer stay-up-to-date email'

    // Request Call Popup state
    const [phone, setPhone] = useState('')
    const [name, setName] = useState('')
    const [active, setActive] = useState(false)
    const [helpType, setHelpType] = useState("Product Help")

function handleChange(e){
    setEmail(e.target.value)
}

function handleSubmit(e){
    e.preventDefault()
    try{
        const formData = {
            email,
            tag
        }
     axios.post('http://localhost:9000/stay-up-to-date')
    }
    catch(err){
        console.log('Error Message:',err)
    }
      
}
function handleRequestCallSubmit(e){
    e.preventDefault()
    const formData = new FormData()
    formData.append({
        helpType,
        phone,
        name
    })
    try{

    }
    catch(err){
        console.log("Request Callback Error Message:", err)
    }
}


    return (
        <div className="footer">
            <div className="sectionArea">
                <div className="section">
                    <h5>Customer Service and Help</h5>
                    <Link to={'/privacy-policy'}><p>Privacy Policy</p></Link>
                    <Link to={'/cancellation-policy'}><p>Cancellation Policy</p></Link>
                </div>
                <div className="section">
                    <h5>Company Information</h5>
                    <Link to="/about">About</Link>
                    <p>Hours of Operation: 9am - 5pm CST</p>
                    <p>Career Opportunities (Coming Soon)</p>
                </div>
                

            </div>
            <div className="napArea">
                <p>Albums and Art</p>
                <p>198 Abner Ln.</p>
                <p>Montgomery, TX 77356</p>
                <p>719-351-0771</p>
                <p>info@albumsandart.com</p>
            </div>
         
        </div>   
    
    )
}